import React, { useEffect } from 'react';
import { ChevronRight, Phone, Store, FileText, ShieldCheck } from 'lucide-react';
export function WholesalePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-1391">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-1392">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-1393">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-1394">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-1395">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-1396" />
            <a href="#/support" className="hover:text-gold transition-colors" data-id="element-1397">
              Support
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-1398" />
            <span className="text-charcoal font-medium" data-id="element-1399">
              Wholesale Information
            </span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-1400">
            Wholesale Information
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-1401">
        <div className="space-y-8" data-id="element-1402">
          {/* Main Content */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-1403">
            <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-1404">
              Do We Sell Wholesale?
            </h2>
            <p className="text-warmGray leading-relaxed text-lg mb-6" data-id="element-1405">
              Yes. We sell to gift shops, home décor stores and other brick and
              mortar stores. We do not sell to other online sellers. A valid tax
              ID number must be provided and a minimum order met.
            </p>

            {/* Requirements */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8" data-id="element-1406">
              <div className="bg-cream-dark p-5 rounded-sm border border-warmBorder text-center" data-id="element-1407">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-1408">
                  <Store className="w-5 h-5 text-gold" data-id="element-1409" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-1410">
                  Brick &amp; Mortar
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-1411">
                  Physical retail stores only
                </p>
              </div>
              <div className="bg-cream-dark p-5 rounded-sm border border-warmBorder text-center" data-id="element-1412">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-1413">
                  <FileText className="w-5 h-5 text-gold" data-id="element-1414" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-1415">
                  Tax ID Required
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-1416">
                  Valid tax ID number needed
                </p>
              </div>
              <div className="bg-cream-dark p-5 rounded-sm border border-warmBorder text-center" data-id="element-1417">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-1418">
                  <ShieldCheck className="w-5 h-5 text-gold" data-id="element-1419" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-1420">
                  Minimum Order
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-1421">
                  Minimum order must be met
                </p>
              </div>
            </div>

            {/* Signup CTA */}
            <div className="bg-cream-dark p-6 md:p-8 rounded-sm border border-warmBorder" data-id="element-1422">
              <a href="#/wholesale-signup" className="inline-flex items-center px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-1423">
                Sign Up as a Wholesale Member
              </a>
              <p className="text-warmGray text-sm mt-3" data-id="element-1424">
                (Business Name and Tax ID number required)
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-charcoal text-cream p-8 md:p-10 rounded-sm" data-id="element-1425">
            <h3 className="text-xl font-serif text-white mb-3" data-id="element-1426">
              For Additional Information
            </h3>
            <p className="text-cream/80 leading-relaxed mb-6" data-id="element-1427">
              Have questions about our wholesale program? Give us a call and
              we'll be happy to help.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-1428">
              <a href="tel:13046863170" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm" data-id="element-1429">
                <Phone size={16} data-id="element-1430" />
                1-304-686-3170
              </a>
              <a href="#/contact" className="inline-flex items-center justify-center px-8 py-3.5 bg-white/10 border border-white/20 text-white hover:bg-white/20 font-bold rounded-sm transition-colors text-sm" data-id="element-1431">
                Contact Us Online
              </a>
            </div>
            <p className="text-cream/60 text-sm mt-4" data-id="element-1432">
              Monday–Friday, 9AM–5PM EST
            </p>
          </div>
        </div>
      </div>
    </section>;
}